module.exports = __webpack_public_path__ + "img/Samurai.88a3d3b3.jpg";